<script setup lang="ts">
import { useId } from 'vue'
defineProps<{ modelValue: number; label: string; min: number; max: number; unit?: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: number] }>()
const id = useId()
</script>
<template>
  <div>
    <div class="mb-3 flex items-center justify-between gap-4">
      <label :for="id" class="text-xs font-medium text-slate-500">{{ label }}</label>
      <output :for="id" class="font-mono text-xs text-ink">{{ modelValue }}{{ unit }}</output>
    </div>
    <input
      :id="id"
      :value="modelValue"
      type="range"
      :min="min"
      :max="max"
      step="1"
      class="range-field w-full"
      @input="emit('update:modelValue', Number(($event.target as HTMLInputElement).value))"
    />
  </div>
</template>
